/* eslint-disable react/prop-types */
import {Component, ReactNode} from 'react';

import PortalBreadcrumbs, {BreadcrumbItem} from './portal-breadcrumbs.component';

import styles from './portal-page-header.component.module.scss';

/**
 * Shared page header used at the top of every portal page.
 *
 * Mirrors the visual rhythm of the Stripe / Claude settings portal:
 * - 24px / 600 page title in `--text-primary`.
 * - Optional 14px subtitle in `--text-muted`.
 * - Optional `actions` slot on the right (buttons / select / etc.).
 * - Optional `breadcrumbs` chip-style above the title.
 *
 * Rendered inside `<PortalLayout>`'s `main` slot. Page padding is owned
 * by this component (32px desktop / 24px mobile, matching §7.0).
 */
export interface PortalPageHeaderProps {
    title: string;
    subtitle?: string;
    actions?: ReactNode;
    breadcrumbs?: BreadcrumbItem[];
}

export default class PortalPageHeader extends Component<PortalPageHeaderProps> {
    render() {
        const {title, subtitle, actions, breadcrumbs} = this.props;
        return (
            <header className={styles.header} data-testid="portal-page-header">
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <div className={styles.breadcrumbWrap}>
                        <PortalBreadcrumbs items={breadcrumbs} />
                    </div>
                )}
                <div className={styles.row}>
                    <div className={styles.titleBlock}>
                        <h1 className={styles.title}>{title}</h1>
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                    {actions && <div className={styles.actions}>{actions}</div>}
                </div>
            </header>
        );
    }
}
